import React from "react";
import { Box, Grid, Typography, Avatar, InputLabel, useTheme, Dialog, DialogTitle, DialogContent } from "@mui/material";
import TextLabel from "../Common/CommonTextLabel";
import { BucketURL } from "../../ApiSetup/Api";
import { makeStyles } from 'tss-react/mui';
import DocPreview from "../Common/DocPreview";
import CloseIcon from '@mui/icons-material/Close';
import { calculateAgeAndMonth, getFileIcon, getLabelbyId, getValuebyId } from "../../Utils/handler";
import { bloodGroupsList, relationList } from "../../Utils/enum";

const useStyles = makeStyles()((theme) => {
  return {
    label: {
      letterSpacing: "0.03em",
      marginRight: "2px",
      fontSize: "14px",
      color: theme?.palette?.primary?.main,
      whiteSpace: "wrap",
      marginBottom: "0px",
      lineHeight: '1rem'
    }
  }
})

const ProfileDetails = ({ personalDetails, generalDetails, nomineeDetails, aadharCard }) => {
  const theme = useTheme()
  const { classes } = useStyles();

  const [preview, setPreview] = React.useState({ open: false, link: "", fileName: "" });
  return (
    <>
      <Box width="100%" >
        <Grid container spacing={2} item md={12} lg={12} xs={12} sm={12} p={1}>

          <Grid item xs={12} sm={12} md={6} lg={6} >
            <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"Personal Detail"} marginBottom={1} />
            <Box component="div" display="grid" alignItems={'center'} gridTemplateColumns="2fr 2fr" rowGap={1} columnGap={2}>

              <InputLabel className={classes.label}>Profile Image :</InputLabel>
              <Avatar src={BucketURL + personalDetails?.image?.[0]} alt="image" sx={{ cursor: 'pointer' }}
                slotProps={{
                  loading: "lazy",
                  cursor: 'pointer'
                }}
                onClick={() => setPreview({ open: true, link: BucketURL + personalDetails?.image?.[0], fileName: personalDetails?.image })}
              />

              <InputLabel className={classes.label}>First Name :</InputLabel>
              <Typography variant="body1">{personalDetails?.firstName || "N/A"}</Typography>

              <InputLabel className={classes.label}>Middle Name:</InputLabel>
              <Typography variant="body1">{personalDetails?.middleName || "N/A"}</Typography>

              <InputLabel className={classes.label}>Last Name :</InputLabel>
              <Typography variant="body1">{personalDetails?.lastName || "N/A"}</Typography>

              <InputLabel className={classes.label}>Role :</InputLabel>
              <Typography variant="body1">{personalDetails?.role || "N/A"}</Typography>

              {personalDetails?.referenceContactNumber && <InputLabel className={classes.label}>Ref. Contact Number :</InputLabel>}
              {personalDetails?.referenceContactNumber && <Typography variant="body1">{personalDetails?.referenceContactNumber || "N/A"}</Typography>}

              <InputLabel className={classes.label}>Village :</InputLabel>
              <Typography variant="body1">{personalDetails?.village || "N/A"}</Typography>

              <InputLabel className={classes.label}>District :</InputLabel>
              <Typography variant="body1">{personalDetails?.district || "N/A"}</Typography>

              <InputLabel className={classes.label}>Taluka :</InputLabel>
              <Typography variant="body1">{personalDetails?.taluka || "N/A"}</Typography>

              <InputLabel className={classes.label}>Age :</InputLabel>
              <Typography variant="body1">{calculateAgeAndMonth(aadharCard?.dob) || "N/A"}</Typography>
            </Box>
          </Grid>

          <Grid item xs={6} sm={12} md={6} lg={6} >
            <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"General Detail"} marginBottom={1} />

            <Box component="div" display="grid" gridTemplateColumns="2fr 2fr" rowGap={1} columnGap={2}>

              <InputLabel className={classes.label}>Gender :</InputLabel>
              <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>{generalDetails?.gender || "N/A"}</Typography>

              <InputLabel className={classes.label}>Phone Number:</InputLabel>
              <Typography variant="body1">{generalDetails?.phoneNumber || "N/A"}</Typography>

              <InputLabel className={classes.label}>Address:</InputLabel>
              <Typography variant="body1">{generalDetails?.addressLine1 || "N/A"}</Typography>

              <InputLabel className={classes.label}>Landmark :</InputLabel>
              <Typography variant="body1">{generalDetails?.landmark || "N/A"}</Typography>

              <InputLabel className={classes.label}>Area :</InputLabel>
              <Typography variant="body1">{generalDetails?.area || "N/A"}</Typography>

              <InputLabel className={classes.label}>City :</InputLabel>
              <Typography variant="body1">{generalDetails?.city || "N/A"}</Typography>

              <InputLabel className={classes.label}>State :</InputLabel>
              <Typography variant="body1">{generalDetails?.state || "N/A"}</Typography>

              <InputLabel className={classes.label}>Country :</InputLabel>
              <Typography variant="body1">{generalDetails?.country || "N/A"}</Typography>

              <InputLabel className={classes.label}>Pincode :</InputLabel>
              <Typography variant="body1">{generalDetails?.pinCode || "N/A"}</Typography>

              <InputLabel className={classes.label}>Mertial Status :</InputLabel>
              <Typography variant="body1">{generalDetails?.maritalStatus || "N/A"}</Typography>

              <InputLabel className={classes.label}>Blood Group :</InputLabel>
              <Typography variant="body1">{generalDetails?.bloodGroup || "N/A"}</Typography>

              <InputLabel className={classes.label}>Education :</InputLabel>
              <Typography variant="body1">{generalDetails?.education || "N/A"}</Typography>

              <InputLabel className={classes.label}>Occupation :</InputLabel>
              <Typography variant="body1">{generalDetails?.occupation || "N/A"}</Typography>

            </Box>

          </Grid>

          {nomineeDetails?.map((nominee, index) => (
            <>
              <Grid item xs={6} sm={12} md={6} lg={6} >
                <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={`Nominee Detail (${index + 1})`} marginBottom={1} />
                <Box
                  key={index}
                  component="div"
                  display="grid"
                  gridTemplateColumns="2fr 2fr"
                  rowGap={1}
                  columnGap={2}
                  marginBottom={2} // Add space between each nominee's details
                >
                  <InputLabel className={classes.label}>Relation:</InputLabel>
                  <Typography variant="body1">{nominee?.relation || "N/A"}</Typography>

                  <InputLabel className={classes.label}>Nominee:</InputLabel>
                  <Typography variant="body1">{nominee?.nomineeName || "N/A"}</Typography>

                  <InputLabel className={classes.label}>Contact Number:</InputLabel>
                  <Typography variant="body1">{nominee?.contactNumber || "N/A"}</Typography>
                </Box>
              </Grid>
            </>
          ))}

          {/* <Box component="div" display="grid" gridTemplateColumns="2fr 2fr" rowGap={1} columnGap={2}>

              <InputLabel className={classes.label}>Relation :</InputLabel>
              <Typography variant="body1">{nomineeDetails?.[0]?.relation || "N/A"}</Typography>

              <InputLabel className={classes.label}>Nominee :</InputLabel>
              <Typography variant="body1">{nomineeDetails?.[0]?.nomineeName || "N/A"}</Typography>

              <InputLabel className={classes.label}>Contact Number :</InputLabel>
              <Typography variant="body1">{nomineeDetails?.[0]?.contactNumber || "N/A"}</Typography>

            </Box> */}


          {preview?.open && (
            <Dialog open={preview?.open} onClose={() => setPreview({ open: false, link: "", fileName: "" })} fullWidth={true}>
              <DialogTitle sx={{ padding: "8px 16px" }}>
                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} >
                  <Typography fontSize={"15px"} fontWeight={700} color={theme.palette.primary.main}>
                    Profile Preview
                  </Typography>
                  <Box display={'flex'} gap={1} justifyContent={'space-between'} alignItems={'center'} >
                    <CloseIcon onClick={() => setPreview({ open: false, link: "", fileName: "" })} style={{ cursor: 'pointer' }} />
                  </Box>
                </Box>
              </DialogTitle>

              <DialogContent>
                <DocPreview
                  link={preview?.link}
                  iconName={getFileIcon(preview?.fileName, preview?.fileName[0])}  // Passing originalDocArray and fileName
                  octateFile={false}
                />
              </DialogContent>

            </Dialog>
          )}


        </Grid>

      </Box >
    </>
  );
};

export default ProfileDetails;
